import { render, staticRenderFns } from "./NumberNStatements.vue?vue&type=template&id=babb5862&scoped=true&"
import script from "./NumberNStatements.vue?vue&type=script&lang=js&"
export * from "./NumberNStatements.vue?vue&type=script&lang=js&"
import style0 from "./NumberNStatements.vue?vue&type=style&index=0&id=babb5862&lang=scss&scoped=true&"
import style1 from "./NumberNStatements.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babb5862",
  null
  
)

export default component.exports